import { FormEvent, useState } from 'react';
import { sendMagicLink } from '../hooks/useAuth';
import { ADMIN_EMAIL } from '../lib/supabase';

export default function Login() {
  const [email, setEmail] = useState(ADMIN_EMAIL);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      await sendMagicLink(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error desconocido');
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="glass rounded-2xl w-full max-w-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex -space-x-1.5">
            <span className="w-3 h-3 rounded-full bg-uan shadow-[0_0_12px_theme(colors.uan.DEFAULT)]"></span>
            <span className="w-3 h-3 rounded-full bg-takion shadow-[0_0_12px_theme(colors.takion.DEFAULT)]"></span>
          </div>
          <h1 className="text-lg font-semibold tracking-tight">Roadmap</h1>
          <span className="ml-auto text-[10px] uppercase tracking-widest text-ink-400">UAN AI · TAKION</span>
        </div>

        {sent ? (
          <div className="space-y-3">
            <p className="text-sm text-ink-200">
              Link enviado a <span className="text-white">{email}</span>.
            </p>
            <p className="text-xs text-ink-400">
              Revisá tu inbox (y spam). El link expira en 1 hora.
            </p>
            <button className="btn mt-2" onClick={() => setSent(false)}>Reenviar</button>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="label" htmlFor="email">Email admin</label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                autoComplete="email"
                required
              />
            </div>
            {error && (
              <div className="text-xs text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-md p-2">
                {error}
              </div>
            )}
            <button type="submit" className="btn-primary w-full justify-center" disabled={sending}>
              {sending ? 'Enviando…' : 'Enviar magic link'}
            </button>
            <p className="text-[11px] text-ink-400 text-center">
              Solo <span className="text-ink-200">{ADMIN_EMAIL}</span> puede acceder.
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
